import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { addUser } from "../redux/slices/usersSlice";

const AddUser = () => {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [role, setRole] = useState("user");
  const [error, setError] = useState(null);

  const token = useSelector((state) => state.auth.token);

  const dispatch = useDispatch();

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const userData = { name, email, password, role };

      await dispatch(addUser({ userData, token })).unwrap();
      console.log("User added successfully");
    } catch (err) {
      setError(err.message || "Error adding user");
      console.error("Error:", err);
    }
  };

  return (
    <div className="p-8 bg-gray-800 text-white">
      <h1 className="text-3xl font-semibold mb-6">Add New User</h1>
      {error && <p className="text-red-500">{error}</p>}
      <form onSubmit={handleSubmit} className="space-y-4">
        <div>
          <label>Name</label>
          <input
            type="text"
            value={name}
            onChange={(e) => setName(e.target.value)}
            required
            className="p-2 mt-2 w-full border rounded-lg bg-gray-700 text-white"
            autocomplete="name"
          />
        </div>
        <div>
          <label>Email</label>
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            className="p-2 mt-2 w-full border rounded-lg bg-gray-700 text-white"
            autocomplete="email"
          />
        </div>
        <div>
          <label>Password</label>
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
            className="p-2 mt-2 w-full border rounded-lg bg-gray-700 text-white"
            autocomplete="current-password"
          />
        </div>
        <div>
          <label>Role</label>
          <select
            value={role}
            onChange={(e) => setRole(e.target.value)}
            required
            className="p-2 mt-2 w-full border rounded-lg bg-gray-700 text-white"
            autocomplete="off"
          >
            <option value="user">User</option>
            <option value="admin">Admin</option>
          </select>
        </div>
        <button
          type="submit"
          className="mt-4 bg-blue-500 text-white p-2 rounded-lg w-full"
        >
          Add User
        </button>
      </form>
    </div>
  );
};

export default AddUser;
